import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { getDescription, getIsEditing, updateDescription } from "containers/Blueprint/reducer";

import { getActiveBlueprintId } from "containers/App/reducer";

import AibleStep from "components/CreateWizard/AibleStep";

class AibleStepContainer extends React.PureComponent {
  render() {
    const { history, blueprintId } = this.props;

    return <AibleStep {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDescription: (description, blueprintId) =>
    dispatch(updateDescription(blueprintId ? blueprintId : "new", ownProps.bId, description))
});

const mapStateToProps = (state, ownProps) => {
  const blueprintId = getActiveBlueprintId(state);

  return {
    blueprintId: blueprintId,
    description: getDescription(state, blueprintId, ownProps.bId),
    isEditing: blueprintId === "new" && ownProps.id === "new" ? true : getIsEditing(state, blueprintId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AibleStepContainer);
